import React, { useEffect, useState } from "react";
import Image from "../../components/Image/Image";
import Difference from "@mui/icons-material/Difference";
import Gavel from "@mui/icons-material/Gavel";
import andreas from "../../assets/images/Andreas.webp";
import Optimera from "../../assets/images/Optimera.webp";
import Boligmappa from "../../assets/images/Boligmappa.webp";
// import BVN from "../../assets/images/BVN.webp";
import globalStyles from "../../constants/globalStyles/theme.json";
import Carousel from "../../components/Carousel/Carousel";
import { Testimonials } from "../../components/TestimonialCard/Testimonials";
import Layout from "../../components/Layout/Layout";
import * as S from "./Styles";

const { colors } = globalStyles;

const Home = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    const img = document.createElement("img");
    img.src = andreas;
    img.onload = () => setIsImageLoaded(true);
  }, []);

  return (
    <Layout
      title="Tømrer og snekker i Vestby | Grønvold Byggservice - Snekkerarbeid med kvalitet"
      description="Grønvold Byggservice er en erfaren tømrer og snekker i Vestby. Vi tilbyr gratis befaring, skreddersydde løsninger og solid håndverk - kontakt oss for en trygg byggeprosess.">
      <S.Container>
        <S.PageTitle>Grønvold Byggservice AS</S.PageTitle>
        <S.ImageContainer>
          {!isImageLoaded ? (
            <S.SkeletonLoader />
          ) : (
            <Image src={andreas} useShadow alt="Snekker" width={"100%"} height={"320px"} />
          )}
        </S.ImageContainer>
        <S.ContainerOne>
          <S.ContainerText>
            <Difference
              style={{
                color: `${colors.primary.black}`,
                height: "40px",
                width: "40px",
              }}
            />
            <h2>Gratis befaring</h2>
            <S.StyledText>
              Vi stiller med gratis befaring og gir deg et uforpliktende tilbud på ønsket arbeid.
            </S.StyledText>
          </S.ContainerText>
          <S.ContainerText>
            <Gavel
              style={{
                color: `${colors.primary.black}`,
                height: "40px",
                width: "40px",
              }}
            />
            <h2>Arbeid etter avtale</h2>
            <S.StyledText>Ingen overraskelser. Vi oppretter kontrakt for hvert prosjekt - og følger den.</S.StyledText>
          </S.ContainerText>
        </S.ContainerOne>
        <S.ContainerTwo>
          <Carousel testimonials={Testimonials} />
        </S.ContainerTwo>
        <S.ContainerThree>
          <S.PartnerImageCard>
            <Image src={Boligmappa} alt="Boligmappa logo" width={"250px"} height={"100px"} />
          </S.PartnerImageCard>
          <S.PartnerImageCard>
            <Image src={Optimera} alt="Optimera logo" width={"250px"} height={"100px"} />
          </S.PartnerImageCard>
          {/* Removed until further notice */}
          {/* <S.PartnerImageCard>
            <Image src={BVN} alt="BVN logo" width={"150px"} height={"100px"} />
          </S.PartnerImageCard> */}
        </S.ContainerThree>
      </S.Container>
    </Layout>
  );
};

export default Home;
